// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_35FFwmIV","successContent":"Pbq8WWuk","icon":"_3tc4nquV","closeIcon":"G81q4QWv","text":"_3Aqm6-Qf"};